import React from 'react'
import { ModalBuilder, Modal, Table, Form } from "@redriver/cinnamon";
import {UserTypeAhead} from "../lookups";
import {bulkTransferSheetOwnership} from "./actions";
import { UserType } from "../../../constants/enums"

const BulkTransferSheetOwnership = ({as: As = Table.MenuItem, user, onSubmitted, ...props}) => {
    return (
        <ModalBuilder
            withForm
            submitAction={bulkTransferSheetOwnership}
            submitParams={user.id}
            onSubmitted={onSubmitted}
            renderTrigger={(showModal) => (
                <As onClick={showModal} {...props}>
                    Bulk Transfer Sheet Ownership
                </As>
            )}
            renderModal={(modalProps, formProps) => (
                <Modal.Confirmation {...modalProps} header="Bulk Transfer Sheet Ownership">
                    <Form {...formProps}>
                        <UserTypeAhead
                            field="transferToUserId"
                            label={`Transfer from ${user.email} to`}
                            placeholder="Search for user"
                            lookupParams={{includeEmail: true, dealerId: user.companyId, includeInternalUsers: true }}
                            required
                        />
                    </Form>
                </Modal.Confirmation>
            )}
        />
    )
}
export default BulkTransferSheetOwnership